// src/hooks/useInView.js
import { useEffect, useState, useRef } from 'react';

const useInView = (options = {}) => {
  const ref = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const node = ref.current; // ✅ Store the ref value at effect start

    if (!node) return;

    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
        observer.unobserve(entry.target); // Remove to allow re-triggering
      }
    }, options);

    observer.observe(node);

    return () => {
      if (node) observer.unobserve(node); // ✅ Use stored node, not ref.current
    };
  }, [ref, options]);

  return [ref, isVisible];
};

export default useInView;
